/**
 * Tax calculation utilities
 * For India: GST rate is 18% for software subscriptions
 */

export const DEFAULT_GST_RATE = 18; // 18% GST for India

export interface TaxCalculation {
  baseAmount: number;
  taxRate: number;
  taxAmount: number;
  totalAmount: number;
}

/**
 * Calculate tax for a given base amount
 * @param baseAmount - The base amount (tax-exclusive)
 * @param taxRate - Tax rate percentage (default: 18% for GST)
 * @returns Tax calculation breakdown
 */
export function calculateTax(
  baseAmount: number,
  taxRate: number = DEFAULT_GST_RATE
): TaxCalculation {
  const taxAmount = (baseAmount * taxRate) / 100;
  const totalAmount = baseAmount + taxAmount;

  return {
    baseAmount: Math.round(baseAmount * 100) / 100, // Round to 2 decimals
    taxRate,
    taxAmount: Math.round(taxAmount * 100) / 100,
    totalAmount: Math.round(totalAmount * 100) / 100
  };
}

/**
 * Format tax rate for display
 */
export function formatTaxRate(taxRate: number): string {
  return `${taxRate}%`;
}

/**
 * Get tax label (GST for India)
 */
export function getTaxLabel(taxRate: number = DEFAULT_GST_RATE): string {
  return `GST (${taxRate}%)`;
}

